import React, {useState} from 'react';
import {observer} from "mobx-react";
import PatientPageStore from "../../Store/PatientPageStore";
import progressCorenerSVG from './Images/progress.svg'

const PatientYearlyResult = observer((props) => {
    //Облучение за год
    const irradiation = PatientPageStore.patientInfo.irradiation
    const yearlyRadiation = (100 * (1.0 - PatientPageStore.patientInfo.irradiation)) + '%'
    //Состояние попапа
    const [popup, setPopup] = useState(false)

    const popupShow = () => {
        setPopup(true)
    }
    const popupHide = () => {
        setPopup(false)
    }

    return (
        <div className='patient__yearly-result page__element'>
            <div className="patient__yearly-result__title">
                Облучение за год: {irradiation} млЗв
            </div>
            <div onClick={popupShow} className="about-radiation">i</div>

            <div className="patient__yearly-result__progress-bar">
                <div style={{width: yearlyRadiation}} className="progress">
                    <img src={progressCorenerSVG}
                         className="progress-corner"/>
                </div>
            </div>
            <div className="max-radiation">
                1 мл3в
            </div>
            {popup ?
                <div className=" fade-in-fwd radiation-popup page__element">
                    Допустимая годовая эффективная доза при проведении профилактических
                    медицинских рентгенологических процедур не должна превышать 1 млЗв.
                    СанПиН 2.6.1.1192-03
                    <div onClick={popupHide} className="close-button"><i className="fas fa-times"/></div>
                </div> : ''}
        </div>


    );

})

export default PatientYearlyResult;